import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { TProjectsUpsellRequestSources } from 'modules/project_management/components/upsells'
import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface IUpsellRequestProps {
  requestSource: TProjectsUpsellRequestSources
  requestEvents: Features
}

const UpsellProjectsModal = ({
  showUpsellModal,
  scheduleUpsell,
  kanbanTasksUpsell,
}: {
  showUpsellModal: boolean
  scheduleUpsell: boolean
  kanbanTasksUpsell: boolean
}) => {
  const [upsellModalIsHidden, setUpsellModalIsHidden] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideProjectsUpsellModal
  )

  const handleModalClose = () => {
    setUpsellModalIsHidden(true)
  }

  const getRequestSource = (): IUpsellRequestProps => {
    if (kanbanTasksUpsell && scheduleUpsell) {
      return {
        requestSource: ProjectsUpsellRequestSources.kanbanAndSchedule,
        requestEvents: Features.projects_tasks,
      }
    }
    if (scheduleUpsell) {
      return {
        requestSource: ProjectsUpsellRequestSources.schedule,
        requestEvents: Features.projects_clients, // we don't have a schedule feature to request here, using the source instead
      }
    }

    return {
      requestSource: ProjectsUpsellRequestSources.kanbanTasks,
      requestEvents: Features.projects_tasks,
    }
  }

  const benefits: string[] = []
  if (scheduleUpsell) {
    benefits.push(i18n.t('project_management.modals.upsell_projects_modal.step_schedule.title'))
  }
  if (kanbanTasksUpsell) {
    benefits.push(i18n.t('project_management.modals.upsell_projects_modal.step_kanban.title'))
  }

  const requestSource = getRequestSource()
  const isOpen = showUpsellModal && !upsellModalIsHidden

  return (
    <UpsellingKit.FeatureModal
      moduleRequested={AvailableModules.projects}
      requestSource={requestSource.requestSource}
      requestReason={ValidReasons.MissingAddon}
      featureRequested={requestSource.requestEvents}
      isOpen={isOpen}
      onClose={handleModalClose}
    />
  )
}

export default UpsellProjectsModal
